import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { NOTIFICATION_SERVICE } from '@eggplant/api-hosts'
import { WEBHOOK } from '@eggplant/routing'
import type { WebhookGetBody } from '@eggplant/types'

interface Props {
  webhookUuid: string
  onSuccess: (webhook: WebhookGetBody) => void
}

const GetWebhookRequest = ({
  webhookUuid,
  onSuccess
}: Props) =>
  <AuthenticatedDataRequest
    method='get'
    onSuccess={onSuccess}
    url={`${NOTIFICATION_SERVICE}/${WEBHOOK}/${webhookUuid}`}
  />

export default GetWebhookRequest
